/*
 * Project: BookingEngine
 * Module: components/common/RadioSelect.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';

import { IconComponent } from '../ds/atoms/icons/iconComponent';
import { getLangValue } from '../../utils/Generic';
import Btn from '../ds/atoms/btn';

class Select extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDetailCode: null,
    };
  }

  onOptionSelected = (option) => (ev) => {
    ev.preventDefault(); // stop form submit if within a Form
    this.props.onSelect(option);
  };

  displayDetails = (code) => () => {
    const selectedCode = this.state.selectedDetailCode === code ? null : code;
    this.setState({ selectedDetailCode: selectedCode });
  };

  renderChildrenHint(index) {
    const hintChild = this.props.children[index];
    if (!hintChild) {
      return null;
    }
    return (
      <div className="RadioSelect__hint">
        {hintChild}
      </div>
    );
  }

  renderShowDetails(detailsField, option) {
    if (this.props.renderShowDetails) {
      return this.props.renderShowDetails(option);
    }
    if (!detailsField) {
      return null;
    }

    const detailsTxt = getLangValue(option, this.props.lang, detailsField);
    if (!detailsTxt) {
      return null;
    }
    const showDetails = option.code === this.state.selectedDetailCode;
    return (
      <div className="RadioSelect__icon" onClick={this.displayDetails(option.code)}>
        <IconComponent icon="open-eye" className="text-primary"/>
        <div className={`info-tooltip ${showDetails ? 'info-tooltip--visible' : ''}`}>
          {/* eslint-disable react/no-danger */}
          <p dangerouslySetInnerHTML={{ __html: detailsTxt }} />
          {/* eslint-enable react/no-danger */}
          {/* <CloseIcon /> */}
          <IconComponent icon="cross" className="absolute top-6 right-4 md:hidden"/>
        </div>
      </div>
    );
  }

  render() {
    const {
      options, selectId, selectedValue, detailsField, extraClass, lang, keyCode, liClass,
    } = this.props;
    return (
      <ul className={`mx-2 ${extraClass}`}>
        {options.map((option, idx) => {
          const id = `RadioSelect_${selectId}_${idx}`;
          const isSelected = option.code === selectedValue.code;
          return (
            <li key={id} className={`flex items-center py-2 font-semibold ${liClass}`}>
              <Btn
                className={` font-sans ${isSelected ? 'text-primary' : ''}`}
                onClick={this.onOptionSelected(option)}
                id={ keyCode && option[keyCode]}>
                <span className={`radio-dot ${isSelected ? 'active' : ''} mr-2`}/>
                {getLangValue(option, lang, 'name')}
              </Btn>
              {this.renderShowDetails(detailsField, option)}
              {this.props.children && this.renderChildrenHint(idx)}
            </li>
          );
        })}
      </ul>
    );
  }
}

Select.propTypes = {
  children: PropTypes.array, // these are the hints for each "li" element
  lang: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
  selectId: PropTypes.string.isRequired,
  extraClass: PropTypes.string,
  liClass: PropTypes.string,
  options: PropTypes.array.isRequired,
  detailsField: PropTypes.string,
  renderShowDetails: PropTypes.func,
  selectedValue: PropTypes.object,
  keyCode: PropTypes.string,
};

Select.defaultProps = {
  selectedValue: {},
  extraClass: '',
  liClass: 'text-base',
  keyCode: undefined,
};

export default Select;
